var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[(_vm.isShow)?_c('span',[_vm._v("竞价结束")]):_c('span',{staticStyle:{"color":"black"}},[(_vm.data)?_c('span',[_vm._v(_vm._s(_vm.data.min)+":"+_vm._s(_vm.data.second))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }